import { useCallback, useState } from "react";
import { PORTFOLIO } from "@data/portfolio";
import useTranslations from "@hooks/useTranslations";
import PortfolioCard from "./PortfolioCard";
import PortfolioModal from "./PortfolioModal";

const Portfolio = () => {
  const t = useTranslations();
  // Les coquilles de modale restent dans le DOM (Bootstrap les cible par id),
  // mais la galerie d'un projet n'est montée qu'à sa première ouverture : sans
  // cela, chaque ImageGallery fait tourner un carrousel autoPlay en arrière-plan.
  const [openedIds, setOpenedIds] = useState(() => new Set());

  const markOpened = useCallback((id) => {
    setOpenedIds((current) =>
      current.has(id) ? current : new Set(current).add(id)
    );
  }, []);

  return (
    <>
      <div className="bostami-page-content-wrap">
        <div className="section-wrapper pl-60 pr-60 pt-60">
          <div className="bostami-page-title-wrap mb-15">
            <h1 className="page-title">{t.portfolio.title}</h1>
          </div>
        </div>
        <div className="section-wrapper pr-60 pl-60 mb-60">
          <div className="row">
            <div className="col-12">
              <div className="row d-flex">
                {PORTFOLIO.map((element) => (
                  <PortfolioCard
                    key={element.id}
                    element={element}
                    modalId={`portfolio-${element.id}`}
                    onOpen={() => markOpened(element.id)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {PORTFOLIO.map((element) => (
        <PortfolioModal
          key={`${element.id}-modal`}
          element={element}
          modalId={`portfolio-${element.id}`}
          renderGallery={openedIds.has(element.id)}
        />
      ))}
    </>
  );
};

export default Portfolio;
